export const GET_TITLES_DATA = 'GET_TITLES_DATA'
export const SET_TITLES_DATA = 'SET_TITLES_DATA'
export const SET_TITLES_ERROR = 'SET_TITLES_ERROR'
export const SET_TITLES_PROCESSING = 'SET_TITLES_PROCESSING'

export function getTitlesData ({ value, type, bundle }) {
  return {
    type: GET_TITLES_DATA,
    payload: { value, type, bundle },
  }
}

export function setTitlesData ({ data }) {
  return {
    type: SET_TITLES_DATA,
    payload: { data },
  }
}

export function setTitlesError ({ error }) {
  return {
    type: SET_TITLES_ERROR,
    payload: { error },
  }
}

export function setTitlesProcessing ({ processing = true }) {
  return {
    type: SET_TITLES_PROCESSING,
    payload: { processing },
  }
}
